"use client";

import styles from "@/styles/containers/language-switcher.module.scss";
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";

import classNames from "classnames/bind";
const css = classNames.bind(styles);

const LanguageSwitcher = () => {
  const router = useRouter();

  const pathname = usePathname();

  const options = [
    {
      country: "Brasil",
      code: "pt-br",
      image: "https://goodies.icons8.com/web/common/header/flags/br.svg",
    },
    {
      country: "EUA",
      code: "en",
      image: "https://goodies.icons8.com/web/common/header/flags/us.svg",
    },
    {
      country: "Espanhol",
      code: "es",
      image: "https://goodies.icons8.com/web/common/header/flags/es.svg",
    },
  ];

  return (
    <div className={styles.languageSwitcher}>
      {options.map((option) => (
        <span
          key={option.code}
          onClick={() => router.push("/" + option.code)}
          className={css({
            language: true,
            selected: option.code === pathname.split("/")[1],
          })}
        >
          <Image
            src={option.image}
            alt={option.country}
            width={50}
            height={35}
          />
        </span>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
